import React, { Component } from "react";

import Admin from "./components/admin";
import Navbar from "./components/navbar";

import { MDBInput, MDBBtn, MDBContainer } from "mdb-react-ui-kit";

import "./stylesheets/navbar.css";

class App extends Component {
   state = {
      authDisplay: true,
      adminDisplay: false
   }

   letUserIn = () => {
      this.setState({ adminDisplay: true, authDisplay: false });
   }

   authenticate = () => {
      if (document.querySelector(".username").value === "RSCS_admin" &&
         document.querySelector(".password").value === "admin@scsr") {
         this.letUserIn(true);
      } else {
         alert("You are not Authorized");
      }
   }

   render() {
      return (
         <>
            <Navbar />
            {
               this.state.authDisplay ?
                  <MDBContainer fluid>
                     <MDBContainer>
                        <MDBInput label="Username" className="username my-4" type="text" />
                        <MDBInput label="Password" className="password mb-4" type="password" />
                        <MDBBtn onClick={this.authenticate}>Log In</MDBBtn>
                     </MDBContainer>
                  </MDBContainer> :
                  (this.state.adminDisplay && <Admin />)
            }
         </>
      );
   }
}

export default App;